// Friendly fallback for the 401/no_session case. iOS Safari ITP
// evicts third-party-like cookies after 7 days of no interaction, and
// the somesay_session cookie has been observed to disappear during
// long idle gaps. The server-side session is fine — the device just
// needs a fresh cookie via /api/auth/verify, which means the user has
// to tap a magic-link from a recent briefing email.
//
// Surfaced in place of raw 401 error chips on the Wilman tab and the
// push-subscribe widget. Keeps the language plain.

export default function SessionExpiredBanner({ compact = false }) {
  if (compact) {
    return (
      <div className="rounded-md border border-copper/40 bg-copper/5 px-3 py-2 text-sm">
        <p className="font-mono text-[10px] uppercase tracking-wider text-copper-dark">
          session expired
        </p>
        <p className="mt-1 text-fg-secondary">
          Check your inbox for a fresh sign-in link from Mr. Wilman, then tap{' '}
          <strong>OPEN TRANSMISSION</strong> to refresh this device.
        </p>
      </div>
    );
  }
  return (
    <div className="card border-copper/40 bg-copper/5 px-4 py-3">
      <p className="font-mono text-[10px] uppercase tracking-wider text-copper-dark">
        session expired · device sign-in required
      </p>
      <p className="mt-2 text-sm text-fg-primary">
        Your sign-in cookie has expired on this device. The transmissions
        archive is still intact server-side — your photos, points, and
        history are untouched.
      </p>
      <p className="mt-2 text-sm text-fg-secondary">
        To restore access, open your inbox and tap the most recent{' '}
        <strong>OPEN TRANSMISSION</strong> link from Mr. Wilman. The link
        plants a fresh cookie and you&apos;re back in. If you don&apos;t see
        a recent email, ask Kishan to re-send.
      </p>
      <p className="mt-3 font-mono text-[10px] uppercase tracking-wider text-fg-tertiary">
        why: iOS Safari evicts cookies after long idle gaps · this is the iOS
        ITP feature, not a bug here
      </p>
    </div>
  );
}
